/**
 * Slugify the title of the FAQ/Glossary question.
 * 1. convert the title to lowercase
 * 2. remove all non-alphanumeric characters
 * 3. replace all spaces with hyphens
 * 4. remove all question marks
 * @example
 * slugifyTitle('What is the difference between a 501(c)(3) and a 501(c)(4)?')
 * // 'what-is-the-difference-between-a-501c3-and-a-501c4'
 * slugifyTitle('How do you power of cryptos scams? Who contributes?')
 * // 'how-do-you-power-of-cryptos-scams-who-contributes'
 */
export const slugifyTitle = (title: string): string =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, '')
    .replace(/ /g, '-')
    .replace(/\?/g, '');
